import {KEYCLOAK_REALM,KEYCLOAK_URL,KEYCLOAK_CLIENTID} from "../utilities/Environment.js";
import Keycloak from "keycloak-js";

const keycloak=new Keycloak({
    "realm": KEYCLOAK_REALM,
    "url": KEYCLOAK_URL,
    "clientId": KEYCLOAK_CLIENTID,
});

// keycloak-js fires onAuthRefreshError then re-throws, causing an unhandled rejection.
// Swallow the re-throw here — error handling runs via the onEvent callback in App.js.
const _updateToken=keycloak.updateToken.bind(keycloak);
keycloak.updateToken=function(minValidity){
    return _updateToken(minValidity).catch((err)=>{
        // Log for debugging; actual error handling runs via onAuthRefreshError in App.js.
        if(err){
            console.warn('[Keycloak] Token refresh failed:',err?.message||err);
        }
    });
};

// Call this before every API request instead of reading keycloak.token directly.
// Silently refreshes if the token has less than 30s of validity left; errors are
// swallowed here and surface via onAuthRefreshError → performSessionExpiredRedirect.
export async function getValidToken(){
    await keycloak.updateToken(30);
    return keycloak.token;
}

export default keycloak;
